import Image from 'next/image';
import { Container, Htag, HtagAlign, HtagVariant } from '../../components';

import styles from './logistic-software.module.css';
import House from '../../public/logistic/house.svg';
import Scooter from '../../public/logistic/scooter.svg';
import List from '../../public/logistic/list.svg';
import Track from '../../public/logistic/track.svg';
import Check from '../../public/logistic/check.svg';
import scooter from '../../public/logistic/scooter.png';
import cloud1 from '../../public/logistic/cloud1.png';
import cloud2 from '../../public/logistic/cloud2.png';

export default function LogisticSoftware() {
  return (
    <div className={styles.root}>
      <Container>
        <Htag
          variant={HtagVariant.h2}
          align={HtagAlign.center}
          className={styles.title}
          tag="h2"
        >
          Logistics Software Solutions We Provide
        </Htag>
        <p className={styles.description}>
          Logistics and supply chain management software solutions, to optimize
          company workflows and enhance cooperation between businesses, their
          partners, and clients
        </p>
        <ul className={styles.list}>
          <li className={styles.item}>
            <div className={styles.card}>
              <House />

              <h5 className={styles.card_title}>Сut Fleet Operational Costs</h5>
              <ul className={styles.card_list}>
                <li className={styles.card_item}>
                  <Check />
                  Warehouse Management Systems (WMS)
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Order picking and fulfillment
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Asset Management Systems
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Mobile and Wearable Technologies
                </li>
              </ul>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.card}>
              <Track />

              <h5 className={styles.card_title}>
                Transportation Management Systems (TMS)
              </h5>
              <ul className={styles.card_list}>
                <li className={styles.card_item}>
                  <Check />
                  Freight tech
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Carrier rating
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Carrier rating
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Fleet management
                </li>
              </ul>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.card}>
              <Scooter />
              <h5 className={styles.card_title}>Last Mile Delivery</h5>
              <ul className={styles.card_list}>
                <li className={styles.card_item}>
                  <Check />
                  Auto dispatching
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Route planning and real-time route optimization
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Digital Proof of delivery
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Smart Tracking
                </li>
              </ul>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.card}>
              <List />

              <h5 className={styles.card_title}>
                Enterprise Resource Planning (ERP)
              </h5>
              <ul className={styles.card_list}>
                <li className={styles.card_item}>
                  <Check />
                  Accounting
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Invoicing
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Order management
                </li>
                <li className={styles.card_item}>
                  <Check />
                  Inventory management
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </Container>
      <div className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.cloud1}>
            <Image alt="Cloud picture" width={249} height={133} src={cloud1} />
          </div>
          <div className={styles.cloud2}>
            <Image alt="Cloud picture" width={310} height={156} src={cloud2} />
          </div>
          <div className={styles.scooter}>
            <Image
              alt="Scooter picture"
              width={1213}
              height={846}
              src={scooter}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
